<template>
  <div>
    <h3 class="mb-100">{{ $t('service.headline.help') }}</h3>

    <LcCard>
      <div class="flex flex-col gap-200">
        <div class="flex items-center gap-100">
          <LcIcon name="question" size="medium" />
          <span class="font-medium">{{ $t('service.help') }}</span>
        </div>
        <div>
          <p>{{ $t('service.supportcontent') }}</p>
        </div>
        <LcButton
          icon="arrow-right"
          icon-position="right"
          variant="secondary"
          @click="isVisible = true"
        >
          {{ $t('service.button.quidgetai') }}
        </LcButton>
      </div>
    </LcCard>

    <QuidgetAiModal v-if="isVisible" @close="isVisible = false" />
  </div>
</template>

<script lang="ts" setup>
const isVisible = defineModel('visible', {
  default: false,
  type: Boolean,
})
</script>
